<div class="mat-card pstn-relative" id="streamCard">
    <session-card-header id="streamCardHeader" class="d-flex-row mat-card-header w-100 mat-elevation-z1 bb-s1 bc-0002">
    </session-card-header>
    <session-card-content id="streamVideoContainer" class="mat-card-content d-flex-i mb-0-i pstn-relative">
    </session-card-content>
    <session-card-footer id="streamFooter" class="mat-card-actions d-block mnh-105px"></session-card-footer>
</div>